
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Building, Users, DollarSign } from 'lucide-react';

const NewYorkPage = () => {
  return (
    <CityPageTemplate
      city="New York"
      state="New York"
      stateAbbr="NY"
      population="8.3 million+"
      majorIndustries={["financial services", "technology", "media", "healthcare", "real estate"]}
      businessChallenges={[
        "Extremely high labor costs and competitive market",
        "Complex NYC employment laws and ordinances",
        "High commercial real estate and operational costs",
        "Diverse workforce management across five boroughs",
        "Strict paid sick leave and scheduling regulations"
      ]}
      peoSolutions={[
        "Premium benefits packages to attract top talent",
        "Expert NYC employment law compliance guidance",
        "Cost-effective HR infrastructure for high-cost market",
        "Multi-location workforce management solutions", 
        "Comprehensive risk management and insurance programs"
      ]}
      localBusinessTypes={[
        { name: "Financial Services", description: "Wall Street, banking, fintech, insurance" },
        { name: "Technology", description: "Startups, SaaS, digital media, AI" },
        { name: "Media & Entertainment", description: "Publishing, advertising, film, TV" },
        { name: "Healthcare", description: "Hospitals, clinics, medical practices" }
      ]}
      metaDescription="Find the best PEOs in New York City with The PEO App. Compare quotes from top NYC Professional Employer Organizations offering comprehensive HR solutions for financial services, tech, and media companies."
      keyFeatures={[
        {
          icon: Building,
          title: "Wall Street Expertise",
          description: "Specialized HR solutions for NYC's financial sector with regulatory compliance and high-value benefits packages."
        },
        {
          icon: Users,
          title: "Diverse Workforce Management",
          description: "Expert HR services for managing NYC's incredibly diverse workforce across all five boroughs."
        },
        {
          icon: DollarSign,
          title: "High-Cost Market Solutions",
          description: "Cost-effective HR strategies designed for New York's premium business environment and competitive talent market."
        }
      ]}
    />
  );
};

export default NewYorkPage;
